<template>
    <div class="activities-priority-icon-button">
        <CompassTooltip
            :arrow="false"
            :content="tooltipContent"
            :contentClass="tooltipContentClass"
            placement="bottom-start"
        >
            <CompassIconButton
                ref="iconButton"
                :size="size"
                :icon="icon"
                :class="iconClass"
                :loading="isPending"
                :data-bot="dataBot"
                :disabled="!enabled"
                @click.stop="updatePriority"
            />
        </CompassTooltip>
    </div>
</template>

<script>
export default {
    props: {
        enabled: {
            type: Boolean,
            default: false,
        },
        isActive: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
            default: 'medium',
        },
        isPending: {
            type: Boolean,
            default: false,
        },
        dataBot: {
            type: String,
            default: '',
        },
    },
    computed: {
        icon() {
            return this.isActive ? 'flash-fill' : 'flash';
        },
        iconClass() {
            return {
                'is-active': this.isActive,
            };
        },
        tooltipContent() {
            if (!this.enabled) {
                return this.$t.__('common.labels.no_permissions_to_perform_this_action');
            }
            return this.isActive ? this.$l10n.__('Déprioriser') : this.$l10n.__('Prioriser');
        },
        tooltipContentClass() {
            return this.isPending
                ? 'activities-priority-icon-button-tooltip-content--is-pending'
                : '';
        },
    },
    methods: {
        updatePriority() {
            if (!this.isPending) {
                this.$emit('clicked');
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.activities-priority-icon-button:deep() {
    .is-active.compass-icon-button > .compass-icon-button__content {
        color: var(--colors-common-background-warning-default);
    }
}
</style>
<style>
.activities-priority-icon-button-tooltip-content--is-pending {
    visibility: hidden;
    opacity: 0;
}
</style>
